import { useState } from 'react';

export type EmployeeDrawerMode = 'ADD' | 'EDIT' | null;

export const useEmployeeFlow = () => {
  const [isEmployeeDrawerOpen, setIsEmployeeDrawerOpen] = useState(false);
  const [employeeDrawerMode, setEmployeeDrawerMode] = useState<EmployeeDrawerMode>(null);
  const [selectedEmployeeId, setSelectedEmployeeId] = useState<string | null>(null);

  const openEmployeeDrawer = (mode: EmployeeDrawerMode, employeeId?: string) => {
    setIsEmployeeDrawerOpen(true);
    setEmployeeDrawerMode(mode);
    setSelectedEmployeeId(employeeId || null);
  };

  const closeEmployeeDrawer = () => {
    setIsEmployeeDrawerOpen(false);
    setEmployeeDrawerMode(null);
    setSelectedEmployeeId(null);
  };

  return {
    isEmployeeDrawerOpen,
    employeeDrawerMode,
    selectedEmployeeId,
    openEmployeeDrawer,
    closeEmployeeDrawer,
  };
};
